module.exports = __webpack_public_path__ + "img/twitter.9266f55.png";